// Small line icons used on the area page. All are decorative; pair them with text.

interface IconProps { size?: number }

const stroke = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
};

export function IconClock({ size = 18 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" />
        </svg>
    );
}

export function IconCalendar({ size = 18 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <rect x="3.5" y="5" width="17" height="15" rx="2" /><path d="M3.5 10h17M8 3v4M16 3v4" />
        </svg>
    );
}

export function IconChart({ size = 18 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
        </svg>
    );
}

export function IconMountain({ size = 18 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <path d="M3 20l6-11 4 6 3-4 5 9z" />
        </svg>
    );
}

export function IconStar({ size = 18 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z" />
        </svg>
    );
}

export function IconRain({ size = 24 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeWidth={1.8} aria-hidden="true" focusable="false">
            <path d="M7 15a4 4 0 0 1-.6-8 5.5 5.5 0 0 1 10.6 1.5A3.3 3.3 0 0 1 17 15z" />
            <path d="M8 18l-1 2.5M12 18l-1 2.5M16 18l-1 2.5" />
        </svg>
    );
}

export function IconInfo({ size = 24 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} strokeWidth={1.8} aria-hidden="true" focusable="false">
            <circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" />
        </svg>
    );
}

export function IconDrop({ size = 10 }: IconProps) {
    return (
        <svg width={size} height={size * 1.2} viewBox="0 0 10 12" fill="currentColor" aria-hidden="true" focusable="false">
            <path d="M5 0C5 0 0 5.6 0 8a5 5 0 0 0 10 0C10 5.6 5 0 5 0z" />
        </svg>
    );
}

export function IconExternal({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" {...stroke} aria-hidden="true" focusable="false">
            <path d="M7 17L17 7M9 7h8v8" />
        </svg>
    );
}
